module.exports = __webpack_public_path__ + "static/media/shield.27a80851.svg";